import { Injectable } from '@angular/core';
import {CrudService} from './services';
import {CashbackGroupMembership} from './dto/cashbackGroup';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {DataListModel} from './models/data-list-model';
import {BankTransferLoad} from './dto/bankTransferLoad';

@Injectable({
  providedIn: 'root'
})
export class CashbackGroupsMembershipService implements CrudService<CashbackGroupMembership>{
  private cashbackGroupId = -1;
  readonly apiPath = 'cashback-groups/';

  constructor(
    private http: HttpClient,
  ) { }

  setCashbackGroup(id: number) {
    this.cashbackGroupId = id;
  }

  add(item: CashbackGroupMembership): Observable<Object> {
    return undefined;
  }

  delete(id: any): Observable<Object> {
    return undefined;
  }

  deleteMany(list: any[]): Observable<Object> {
    return undefined;
  }

  get(id: any): Observable<CashbackGroupMembership> {
    return undefined;
  }

  getMany(pageIndex: number, pageSize: number, sortField: string, sortDirection: string, filterString: string, dateFilterCols: string[], startFilterDate: Date, endFilterDate: Date, someAdditionalData: string, additionalFilterData?: string[], enumFilter?: { key: string; value: string }, companiesFilter?: string[], additionalField1?: string, additionalField2?: string, additionalValue1?: string, additionalValue2?: string): Observable<DataListModel<CashbackGroupMembership>> {
    const params = new HttpParams()
      .set( 'page', pageIndex.toString() )
      .set( 'pageSize', pageSize.toString() )
      .set( 'filterString', filterString )
      .set( 'sortField', sortField )
      .set( 'sortDirection', sortDirection );
    return this.http.get( this.apiPath + this.cashbackGroupId + '/memberships', { params } ) as Observable<DataListModel<CashbackGroupMembership>>;
  }

  restore(id: any): Observable<Object> {
    return undefined;
  }

  restoreMany(list: any[]): Observable<Object> {
    return undefined;
  }

  update(id: any, item: CashbackGroupMembership): Observable<Object> {
    return undefined;
  }
}
